module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[94]215.5756714.woff2";